import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import BasicInformation from './BasicInformation';
import ApplicationStatus from './ApplicationStatus';
import AdmitStatus from './AdmitStatus';
import ShipStatus from './ShipStatus';
import AcademicActionPlan from './AcademicActionPlan';
import SignatoryStatement from './SignatoryStatement';
import PermissionSplash from 'components/PermissionSplash';


export default class Admissions extends React.Component {
	render() {
		let routeProps = this.props;
		const read = this.props.userRole !== undefined ? this.props.userRole.some(role => {
			return (role.section === 'Admissions' && role.access_read === "1")
		}) : false
	if ((this.props.variant === 'admin' && read === true) || this.props.variant !== 'admin') {
			return (
				<Switch>
					<Route path="/portal/admissions/Basic Information" render={() => <BasicInformation {...routeProps} />} />
					<Route path="/portal/admissions/Application Status" render={() => <ApplicationStatus {...routeProps} />} />
					<Route path="/portal/admissions/Admit Status" render={() => <AdmitStatus {...routeProps} />} />
					<Route path="/portal/admissions/Ship Status" render={() => <ShipStatus {...routeProps} />} />
					<Route path="/portal/admissions/Academic Action Plan" render={() => <AcademicActionPlan {...routeProps} />} />
					<Route path="/portal/admissions/Signatory Statement" render={() => <SignatoryStatement {...routeProps} />} />
					<Route path="*" render={() => <Redirect to="/portal/admissions/Basic Information" />} />
				</Switch>
			);
		} else {
			return (

				<PermissionSplash />

			);
		}
	}
}


// WEBPACK FOOTER //
// ./portal-components/Portal/Admissions/index.jsx